export default "__VITE_ASSET__DeZQBpgY__"